/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GenerateSigningLinkPayload = {
    email: string;
    firstName?: (string | null);
    lastName?: (string | null);
    blockIds?: (Array<string> | null);
    linkType?: GenerateSigningLinkPayload.linkType;
};

export namespace GenerateSigningLinkPayload {

    export enum linkType {
        TOKEN = 'token',
        DIRECT = 'direct',
    }


}

